module.exports = __webpack_public_path__ + "static/img/020.394f3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/020.png
// module id = zDvc
// module chunks = 0